export const QUIZ = "QUIZ"
export const QUIZ_SUCCESS = "QUIZ_SUCCESS"
export const QUIZ_FAILURE = "QUIZ_FAILURE"

export const ATTEMPT_QUIZ = "ATTEMPT_QUIZ"
export const ATTEMPT_QUIZ_SUCCESS = "ATTEMPT_QUIZ_SUCCESS"
export const ATTEMPT_QUIZ_FAILURE = "ATTEMPT_QUIZ_FAILURE"

export const SET_INDEX = "SET_INDEX"
export const RESET_INDEX = "RESET_INDEX"

export const QUIZ_FINISHED = "QUIZ_FINISHED"

export const RESET_QUIZ = "RESET_QUIZ";
export const SET_POINTS = "SET_POINTS";
